const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const getDistinctLeadCampaignsApi = async () => {
    const token = localStorage.getItem('token');
    try {
        const response = await fetch(
            `${API_BASE_URL}/common/lead/filters/campaigns`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData?.message || 'Ошибка при получении списка кампаний');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Ошибка при получении списка кампаний:', error);
        throw error;
    }
};